<template>
  <div class="wy-smart-tag-dashboard-table-page-detail" v-loading="loading">
    <div class="wy-page-title">
      <el-tooltip class="item" effect="dark" content="Go Back" placement="bottom">
        <el-button class="el-smart-tags-back" data-testid="AiTags-AiGeneratedTags-TagDetail-Button-GoBackToMainPage" @click="handleBack"></el-button>
      </el-tooltip>
      <div class="wy-page-subtitle" ref="subTitle" :title="topicName">
        {{ topicName }}
      </div>
    </div>
    <div class="wy-page-tab" v-if="currentItem">
      <el-tabs ref="tabs" v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane v-if="isTabEnable('metrics', 4900)" label="Metrics" name="metrics">
          <detailMetrics ref="metrics" :parent="module" :activeTab="activeTab" />
        </el-tab-pane>

        <el-tab-pane v-if="isTabEnable('associatedTopics', 4900)" label="Associated topics" name="associatedTopics">
          <associatedTopics ref="associatedTopics" :parent="module" :activeTab="activeTab" />
        </el-tab-pane>
      
        <el-tab-pane v-if="isTabEnable('detailPhraseHit', 4900)" label="Associated phrase hits" name="detailPhraseHit" style="padding: 25px;">
          <detailPhraseHit ref="detailPhraseHit" :parent="module" :activeTab="activeTab" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-else class="no-result-found">
      <div class="no-data"></div>
      <div class="no-data-title">{{ $t('noResultFound.title') }}</div>
      <div class="no-data-content">
        <div class="content-text">
          {{ $t('noResultFound.message') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import detailMetrics from './wy-smart-tag-dashboard-table-detail-metrics';
import associatedTopics from './wy-smart-tag-dashboard-table-detail-associated-topics';
import detailPhraseHit from './wy-smart-tag-dashboard-table-detail-associated-phrase-hit';

export default Vue.extend({
  name: 'wy-smart-tag-dashboard-table-page-detail',
  props: ['parent', 'selectedItem'],

  components: {
    detailMetrics: detailMetrics,
    associatedTopics: associatedTopics,
    detailPhraseHit: detailPhraseHit,
  },

  data() {
    return {
      module: this,
      loading: false,
      activeTab: 'metrics',
      isEditTopicName: false,
      topicName: null,
      isClickEdit: false,
      currentItem: null,
      fetchData: true,
    };
  },

  computed: {
    ...mapGetters(['dataModel', 'isC1Auth', 'config', 'tableModel', 'isRoleAllow', 'authUser']),

    showMetricsTab() {
      if (!this.currentItem) return;

      const avgBes = this.currentItem.avgBes;
      const avgBas = this.currentItem.avgBas;

      const scoreIsHundred = avgBes == 100 && avgBas == 100;
      const scoreIsNegativeOne = avgBes == -1 && avgBas == -1;

      if (scoreIsHundred || scoreIsNegativeOne) {
        return false;
      }

      return true;
    },
  },

  watch: {
    topicName(value) {
      if (this.$refs.detailPhraseHit) {
        this.$refs.detailPhraseHit.groupName = value;
      }
    },
    isEditTopicName(value) {
      let dom = this.$refs.subTitle;
      if (dom && value) {
        dom.style.border = '1px solid #CAD2DA';
        dom.style['min-width'] = '200px';
      }
    },
  },

  methods: {
    ...mapMutations(['updateTranscriptInfoReference']),
    
    isTabEnable(key, aclCode) {
      if (this.config.tabs == null || this.config.tabs[key] == null || this.config.tabs[key].enabled == null || this.config.tabs[key].enabled === true) {
        return this.isRoleAllow(aclCode);
      }
      return false;
    },

    resetFetchDataStatus() {
      if (this.$refs.metrics) this.$refs.metrics.fetchData = true;
      if (this.$refs.associatedTopics) this.$refs.associatedTopics.fetchData = true;
      if (this.$refs.detailPhraseHit) this.$refs.detailPhraseHit.fetchData = true;
    },

    refreshUI(item, options) {

      if (!item) {
        this.activeTab = 'metrics';
      }

      this.currentItem = item;
      this.resetFetchDataStatus();
      if (this.currentItem) {
        if (this.activeTab == 'metrics' && this.$refs.metrics) this.$refs.metrics.loadData();
        if (this.activeTab == 'associatedTopics' && this.$refs.associatedTopics) this.$refs.associatedTopics.loadTopicGroup(true, options.filterName);
        if (this.activeTab == 'detailPhraseHit' && this.$refs.detailPhraseHit) this.$refs.detailPhraseHit.loadTagCategories();
      } else {
        this.parent.loading = false;
      }
    },

    handleBack() {
      this.$parent.close();
    },

    handleTabClick(tab) {
      if(this.$root.preMsgObj) {
        this.$root.preMsgObj.visible = false;
        this.$root.preMsgObj.onClose()
      }
      if (this.$refs[tab.name]) {
        this.$refs[tab.name].startLoading();
      }
    },

    stopLoadingByTab(tab) {
      if (this.activeTab == tab) {
        this.parent.loading = false;
      }
    }
  },

  mounted() {
    setTimeout(() => {
      document.getElementById('tab-metrics') ? document.getElementById('tab-metrics').setAttribute('data-testid', 'AiTags-AiGeneratedTags-TagDetail-MetricsTab') : undefined;
      document.getElementById('tab-associatedTopics') ? document.getElementById('tab-associatedTopics').setAttribute('data-testid', 'AiTags-AiGeneratedTags-TagDetail-AssociatedTopicsTab') : undefined;
      document.getElementById('tab-detailPhraseHit') ? document.getElementById('tab-detailPhraseHit').setAttribute('data-testid', 'AiTags-AiGeneratedTags-TagDetail-DetailPhraseHitTab') : undefined;
    }, 10);
  },

  async created() {
    this.currentItem = this.selectedItem;
    this.topicName = this.currentItem.smartTagName.replace(/(<([^>]+)>)/gi, '');
    setTimeout(() => {
      let editorEle = this.$refs.subTitle;
      if (editorEle) {
        editorEle.addEventListener('paste', function(e) {
          e.preventDefault();
          const text = e.clipboardData ? (e.originalEvent || e).clipboardData.getData('text/plain') : window.clipboardData ? window.clipboardData.getData('Text') : '';
          if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, text);
          } else {
            const range = document.getSelection().getRangeAt(0);
            range.deleteContents();
            const textNode = document.createTextNode(text);
            range.insertNode(textNode);
            range.selectNodeContents(textNode);
            range.collapse(false);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
        });
      }
    }, 600);
  },

  beforeDestroy() {
    this.$root.$el.classList.remove('smartTagDashboardDetail');
    this.parent.$refs.table.$el.style.display = 'block';
    if(this.$root.preMsgObj) {
      this.$root.preMsgObj.visible = false;
      this.$root.preMsgObj.onClose()
    }
  },
});
</script>

<style lang="scss">
.wy-smart-tag-dashboard-table-page-detail {
  // min-width: 1180px;
  // min-width: 1382px;
  padding-right: 0px;
  //margin-bottom: 20px;
  padding-top: 0px;

  .wy-page-title {
    height: 57px;
    display: flex;
  }

  .el-table__body-wrapper {
    position: sticky !important;
    overflow-y: auto !important;
    height: calc(100vh - 440px);
  }
  .wy-page-subtitle {
    display: inline-block;
    margin: 0px 10px 0px 10px;
    font-size: 21px;
    background: transparent 0% 0% no-repeat padding-box;
    border: 3px solid transparent;
    border-radius: 5px;
    opacity: 1;
    padding: 5px 30px 5px 5px;
    position: relative;
    top: 3px;
    vertical-align: middle;
    outline: none;
    // max-width: 450px;
    max-width: 600px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid transparent !important;
  }
  [contenteditable='true'].wy-page-subtitle {
    white-space: nowrap;
    height: 27px;
    max-width: 650px;
    overflow: hidden;
    text-overflow: unset;
    border: 1px solid #cad2da !important;
  }
  [contenteditable='true'].wy-page-subtitle:focus {
    border: 1px solid #106fbc !important;
  }
  [contenteditable='true'].wy-page-subtitle br {
    display: none;
  }
  [contenteditable='true'].wy-page-subtitle * {
    display: inline;
    white-space: nowrap;
    text-overflow: unset;
  }

  .el-button {
    padding: 7px 15px 21px 10px;
    margin-left: 0px;
    margin-right: 11px;
  }
  .el-smart-tags-back {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_back.svg') !important;
    background-size: 44px;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    background-color: #f2f2f2;
    height: 44px;
    width: 44px;
    border: 0px;
  }
  .el-smart-tags-back:hover {
    background-color: #ebf4fd !important;
    background-position-y: 0px;
    background-position-x: 0px;
  }

  .el-edit-pencil {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_edit_pencil.svg') !important;
    background-size: 16px;
    background-repeat: no-repeat;
    background-position-y: 9px;
    background-position-x: 7px;
    background-color: transparent;
    height: 30px;
    width: 30px;
    border: 0px;
    position: relative;
    top: 3px;
  }
  .el-edit-pencil:hover {
    background-color: #ebf4fd !important;
  }
  .el-topic_confirm {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_topic_confirm.svg') !important;
    background-size: 24px;
    background-repeat: no-repeat;
    background-position-y: 10px;
    background-position-x: 9px;
    background-color: transparent;
    height: 36px;
    width: 40px;
    border: 0px;
    padding-bottom: 12px;
    margin-left: 38px;
  }
  .span-between {
    border-right: 2px solid #ecedef;
    position: absolute;
    top: 12px;
  }
  .el-topic_cancel {
    cursor: pointer;
    position: relative;
    font-weight: 500;
    background-color: unset;
    color: #106fbc;
    border: unset;
    border-right: 15px solid transparent !important;
    font-family: 'Helvetica Neue', sans-serif;
    transition: 0s;
    span {
      top: 5px;
      position: relative;
    }
    &:hover {
      background-color: unset;
    }
  }

  .wy-page-link {
    cursor: pointer;
    display: inline-block;
    border-bottom: 2px solid #fff;
  }
  .wy-page-link:hover {
    border-bottom: 2px solid #002852;
  }

  .wy-page-tab {
    border-radius: 5px;
    padding-top: 10px;
    padding-bottom: 3px;

    .el-tabs__active-bar {
      width: var(--site-tab-item-width);
      background-color: var(--site-tab-item-underline-background-color);
      height: var(--site-tab-item-underline-height);
      padding: var(--site-tab-item-underline-padding);
      left: var(--site-tab-item-underline-left);
    }
    .el-tabs__item {
      padding: var(--site-tab-item-padding);
      height: 35px;
      line-height: 26px;
      width: var(--site-tab-item-width) !important;
      box-sizing: content-box;
      text-align: center;
      color: var(--site-tab-item-color);
      font-weight: 400;
      font-size: var(--site-tab-item-font-size);
      border: var(--site-tab-item-border);
      background-color: var(--site-tab-item-background-color);
      margin-right: var(--site-tab-item-margin-right);
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      padding-top: 7px;
    }
    .el-tabs__item.is-top:nth-child(2) {
      padding-left: var(--site-tab-item-padding-nth-child);
    } 
    .el-tabs__item.is-active {
      background-color: var(--site-tab-active-item-background-color);
      color: var(--site-tab-active-item-color);
    }

    .el-tabs__nav-wrap::after {
      height: 1px;
    }
    #pane-detailPhraseHit.el-tab-pane {
      padding: 25px 0px 0px 25px !important;
    }
    #pane-messages,
    #pane-topicRelations,
    #pane-associatedTopics,
    #pane-detailPhraseHit {
      padding: 25px 25px 0px 25px !important;
      &::-webkit-scrollbar {
        width: 20px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 160px;
        border: 2px solid transparent;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#F3F6F8;
        border-top: 1px solid #CAD2DA;
        border-bottom: 1px solid #CAD2DA;
      }
    }
    #pane-messages,
    #pane-topicRelations,
    #pane-associatedTopics,
    #pane-detailPhraseHit {
      overflow-x: auto;
      overflow-y: hidden;
    }
    #pane-messages {
      margin-right: 20px;
    }
    #pane-associatedTopics {
      overflow-x: auto;
      &::-webkit-scrollbar-thumb {
        border-radius: 160px !important;
        border: 2px solid transparent !important;
        border-top: 4px solid transparent !important;
        border-bottom: 4px solid transparent !important;
        background-clip: content-box !important;
        background-color: #CAD2DA !important;
      }
      &::-webkit-scrollbar-track {
        background:#F3F6F8 !important;
        border-top: 1px solid #CAD2DA !important;
        border-bottom: 1px solid #CAD2DA !important;
      }
    }

    #pane-metrics {
      overflow-x: auto;
      .wy-smart-tag-dashboard-table-page-detail-metrics {
        min-width: 1393px;
        height: calc(100vh - 270px) !important;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 20px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 160px;
          border: 2px solid transparent;
          border-top: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track {
          background:#fff;
          border-top: 1px solid #CAD2DA;
        }
        &::-webkit-scrollbar:vertical {
          width: 18px;
        }
        &::-webkit-scrollbar-thumb:vertical {
          border-radius: 160px;
          border: 2px solid transparent;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track:vertical {
          border-top: none !important;
        }
      }
      &::-webkit-scrollbar {
        width: 20px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 160px;
        border: 2px solid transparent;
        border-top: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#fff;
        border-top: 1px solid #CAD2DA;
      }
      &::-webkit-scrollbar:vertical {
        width: 14px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 2px solid transparent;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        border-top: none !important;
      }
    }

    #pane-metricAnalysis {
      overflow-x: auto;
      padding-right: 0px !important;
      padding-bottom: 10px !important;
    }
    #pane-intents {
      overflow-x: auto;
    }
  }

  .el-tabs__header {
    margin: 0;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
  }

  .el-tabs.el-tabs--top {
    .el-tabs__content {
      // height: 506px;
      border: 1px solid #cad2da;
      background-color: #ffffff !important;
      // box-shadow: 0px 0px 6px #00000014;
    }
  }

  .no-topic-content {
    color: var(--site-font-primary-color);
    background-color: transparent;
    margin-bottom: 3px;
    height: calc(100vh - 590px);

    .no-data {
      text-align: center;
      display: block;
      border: none;
      height: 220px;
      margin-top: 120px;
      background-position-x: 50%;
      background-repeat: no-repeat;
      background-size: 300px;
      background-image: url('../../assets/images/analytics/empty_saved_transcript.svg');
    }
    .no-data-title {
      width: 100%;
      margin-top: 0px;
      text-align: center;
      font-size: 20px;
      color: var(--site-font-primary-color) !important;
      font-weight: 600;
    }
    .no-data-content-first-row {
      width: 100%;
      text-align: center;
      color: var(--site-font-primary-color) !important;
      padding-top: 16px;
      font-size: 14px;
      font-weight: 500;
    }
    .no-data-content-second-row {
      width: 100%;
      text-align: center;
      color: var(--site-font-primary-color) !important;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .el-message--warning {
    background-color: #fdf6ec;
    border-color: #faecd8;
    font-weight: 500;

    .btn-undo {
      border-radius: 5px;
      padding: 5px;
      border: 1px;
      background-color: #e2ecf7;
      font-weight: 600;
      color: #214586;
      color: #005eb8;
    }
    .btn-undo:hover {
      background-color: #e2ecf7;
    }
  }
  .el-message {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: #fff;
    position: fixed;
    left: 50%;
    top: 90px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color: #395167;
    -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
    transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
    transition: opacity 0.3s, transform 0.4s, top 0.4s;
    transition: opacity 0.3s, transform 0.4s, top 0.4s, -webkit-transform 0.4s;
    padding: 15px 15px 15px 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    // background: #FCFCFC 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #015cb9;
    border-radius: 15px;
    width: fit-content !important;
    min-width: unset;
  }
  .el-message .el-icon-warning {
    color: var(--site-font-primary-color) !important;
  }
  .el-message__icon {
    margin-right: 10px;
  }
  .el-icon-warning:before {
    content: '\E7A3';
  }
  .el-message--warning .el-message__content {
    color: #fff !important;
    padding-right: 30px;
  }
  .undo-merge-success-message .el-message__content {
    padding-right: 0px;
  }
  .el-message.undo-merge-message p {
    padding-right: 30px !important;
  }
  .el-message p {
    padding-right: 4px !important;
  }
  .el-message__content {
    padding: 0;
    font-size: 14px;
    line-height: 1;
  }

  .el-loading-mask {
    height: unset !important;
    opacity: unset;
    background-color: unset;
    .el-loading-spinner {
      top: 35%;
      background: var(--site-loading-icon);
      background-repeat: no-repeat;
      background-size: 25px;
      background-position: center;
    }
    .el-loading-spinner .circular {
      display: unset !important;
    }
  }
}
</style>
